<template>
  <div class="renewal">
    <div>
      <img src="@/assets/house/update.gif"
           alt="">
      <p style="color:#6363f0;text-align: center;font-size:20px;font-weight:bold;">正在更新中……</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { createStore } from "@/store";
const store = createStore();
export default {
  data () {
    return {
      timer: null
    }
  },
  methods: {

    async checkIsUpdate () {
      await axios({
        headers: {
          Authorization: store.state.user.token,
        },
        method: "get",
        url: `/api/lib/listLib`
      })
        .then((res) => {
          let { status, data, message } = res;
          if (data.status) {
            localStorage.removeItem("loginInfo");
            sessionStorage.removeItem("roleCode");
            localStorage.removeItem("token");
            localStorage.removeItem("createUid");
            localStorage.removeItem("powers");
            localStorage.removeItem("firstPage");
            sessionStorage.removeItem("picLove");
            clearInterval(this.timer)

            this.$router.push('/loginNoToken')
          }
        })
        .catch((error) => {
          console.log("失败" + error.response.status);
        });
    },

  },
  created () {
    this.timer = setInterval(() => {
      this.checkIsUpdate()
    }, 2000);

  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.renewal {
  background: #ffffff;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
